import { render, staticRenderFns } from "./DACard.vue?vue&type=template&id=5eea7940"
import script from "./DACard.vue?vue&type=script&lang=js"
export * from "./DACard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports